import styled from "styled-components";

export default styled.p`
  padding: 0;
  margin: 0;
  font-size: 16px;
  color: #504f51;

  & > a {
    color: #306ba5;
  }
`;
